import { render, staticRenderFns } from "./side.vue?vue&type=template&id=ba251400&scoped=true"
import script from "./side.vue?vue&type=script&lang=js"
export * from "./side.vue?vue&type=script&lang=js"
import style0 from "./side.vue?vue&type=style&index=0&id=ba251400&prod&lang=scss&scoped=true"
import style1 from "./side.vue?vue&type=style&index=1&id=ba251400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba251400",
  null
  
)

export default component.exports